export default __webpack_public_path__ + "static/media/AngularJS.ad516308.png";